import { createIcon } from './createIcon'

export const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 11 12',
  path: [
    <path
      d="M5.5 1.5V10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M1 6H10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
